import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  SERVICELANEDROPDOWNS_FEATURE_KEY,
  initialState as serviceLaneDropdownsInitialState,
  serviceLaneDropdownsReducer
} from './+state/service-lane-dropdowns.reducer';
import { ServiceLaneDropdownsEffects } from './+state/service-lane-dropdowns.effects';
import { ServiceLaneDropdownsFacade } from './+state/service-lane-dropdowns.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(SERVICELANEDROPDOWNS_FEATURE_KEY, serviceLaneDropdownsReducer),
    EffectsModule.forFeature([ServiceLaneDropdownsEffects])
  ],
  providers: [ServiceLaneDropdownsFacade]
})
export class ServiceLaneDropdownsModule {}
